import type { FC } from 'react';

import { type MaskedInputProps } from 'react-text-mask'

import { MaskedInputStyled } from './styles/MaskedInputStyled'

export const MaskedInput: FC<MaskedInputProps> = (props) => (
  <MaskedInputStyled {...props} />
)

MaskedInput.displayName = 'MaskedInput'
